export const CREATE_NETWORK = 'CREATE_NETWORK';
export const SAVE_NETWORK = 'SAVE_NETWORK';
export const UPDATE_NETWORK = 'UPDATE_NETWORK';
export const UPDATE_NETWORKS_LIST = 'UPDATE_NETWORKS_LIST';
